/** Round numeric values for report display (default 2 decimal places). */
export function roundToDecimals(value, decimals = 2) {
  const num = Number(value);
  if (!Number.isFinite(num)) return 0;
  const factor = 10 ** decimals;
  return Math.round(num * factor) / factor;
}

/** Format a percentage for UI (e.g. 87.456 → "87.46%"). */
export function formatPercent(value, decimals = 2) {
  return `${roundToDecimals(value, decimals)}%`;
}
